import React from 'react';
import styled from '@xstyled/styled-components';
import { Item, registry, RenderProps } from '../Item';
import { CHART_PIE } from '../itemIds';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend);

interface ItemDef {
  title: string;
  subtitle: string;
  body: string;
}

interface Props {
  title?: string;
  subtitle?: string;
  items: Array<ItemDef>;
}

const Wrapper = styled.divBox`
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  padding-bottom: 30px;
  width: 100%;
`;

export class ChartPie extends Item<typeof CHART_PIE, Props> {
  protected render({title, subtitle, items}: RenderProps<Props>) {

    const labels: string[] = [];
    const dataForChart: number[] = [];
    const backgroundColor: string[] = [];
    const borderColor: string[] = [];
    const ariaLabel: string[] = [];

    if (items && items.length) {
      items.forEach((item: ItemDef) => {
        labels.push(item?.title);
        dataForChart.push(Number(item?.subtitle));

        ariaLabel.push(`${item?.title} ${item?.subtitle}%`);

        const colors = item?.body?.replace(/<\/?[^>]+(>|$)/g, "")?.split(',');
        if (colors && colors[0]) {
          backgroundColor.push(colors[0]);
        }
        if (colors && colors[1]) {
          borderColor.push(colors[1]);
        }
      });
    }

    const data = {
      labels: labels,
      datasets: [
        {
          label: title,
          data: dataForChart,
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: 1,
        },
      ],
    };

    const options = {
      plugins: {
        legend: {
          position: 'top' as const,
          interaction: {
            mode: false,
            intersect: false,
          },
          onHover: (event: any) => {
            return false;
          },
          onClick: (event: any) => {
            return false;
          },
        },
        tooltip: {
          enabled: false
        },
        datalabels: {
          display: true,
          weight: "bold",
          color: "#FFF",
          font: {
            size: 22
          },
        }
      }
    };

    return (
      <Wrapper>
        <Pie data={data} aria-label={ariaLabel.join(', ')} role="img" plugins={[ChartDataLabels] as any} options={options} />
      </Wrapper>
    );
  }
}

registry[CHART_PIE] = ChartPie;
